import { createAuthClient } from "better-auth/client";
import { twoFactorClient } from "better-auth/client/plugins";

// Staff Better Auth instance in apps/api (docs/ARCHITECTURE.md → Staff Authentication).
export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: "/api/auth",
  plugins: [twoFactorClient()],
});

/** Better Auth answers in English; staff see Turkish messages. */
export function authErrorMessage(error: { status?: number; code?: string; message?: string }) {
  switch (error.code) {
    case "INVALID_EMAIL_OR_PASSWORD":
      return "E-posta veya şifre hatalı.";
    case "INVALID_PASSWORD":
      return "Şifre hatalı.";
    case "INVALID_CODE":
    case "INVALID_BACKUP_CODE":
      return "Kod hatalı. Uygulamadaki güncel kodu gir.";
    case "INVALID_TWO_FACTOR_COOKIE":
      return "Doğrulama süresi doldu. Tekrar giriş yap.";
    case "ACCOUNT_TEMPORARILY_LOCKED":
    case "TOO_MANY_ATTEMPTS_REQUEST_NEW_CODE":
      return "Çok fazla hatalı kod girildi. Hesabın 15 dakika kilitlendi.";
    case "PASSWORD_TOO_SHORT":
      return "Yeni şifre en az 12 karakter olmalı.";
    default:
      if (error.status === 429) return "Çok fazla deneme yaptın. Bir dakika sonra tekrar dene.";
      return error.status === 403 && error.message
        ? error.message
        : "İşlem tamamlanamadı. Tekrar dene.";
  }
}
